import Paginacao from '@/core/store/default/paginacaoListagem'

export default {
	filtro: {
		id: null,
		descricao: null,
		numero: null,
		tipoAta: null,
		orgao: {
			id: null,
			sigla: null,
		},
		ano: null,
	},
	paginacao: Paginacao(['numero'], 100),
	modelFiltro: {
		id: null,
		descricao: null,
		numero: null,
		tipoAta: null,
		orgao: null,
		ano: null,
	},
}
